import React, { useState, useEffect } from 'react'

import { Header, PageWithTitle, CenteredContent, PageWithTitleBody } from '../styles/Containers'
import { PageTitle } from '../styles/Text'
import { formatPIRForDashboard } from '../../util/pirFormatting'
import axios from '../../dataClient/dataClient'
import Loading from '../common/Loading'
import LoadingError from '../common/LoadingError'
import FilteredPIRs from '../pir/FilteredPIRs'
import pirTerminology from '../../util/pirTerminology'

function PIRDashboardPage() {
  const [pirList, setPirList] = useState([])

  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState()

  useEffect(() => {
    axios
      .get(`/pir`)
      .then(({ data }) => {
        const formattedPirs = data.data.map(p => formatPIRForDashboard(p))
        setPirList(formattedPirs)
        setIsLoading(false)
      })
      .catch(e => {
        console.error('Failed retrieving all PIRs', e)
        setError(true)
        setIsLoading(false)
      })
  }, [])

  return (
    <PageWithTitle gap="15px">
      <Header>
        <PageTitle>Dashboard</PageTitle>
      </Header>
      <CenteredContent>
        {isLoading && (
          <PageWithTitleBody>
            <Loading />
          </PageWithTitleBody>
        )}
        {error && (
          <PageWithTitleBody>
            <LoadingError
              message={[
                "We're sorry.",
                `There was an error loading your ${pirTerminology.getRequestPluralName()}.`,
                'Please refresh the page to try again.'
              ]}
            />
          </PageWithTitleBody>
        )}
        {!isLoading && !error && <FilteredPIRs pirList={pirList} />}
      </CenteredContent>
    </PageWithTitle>
  )
}

export default PIRDashboardPage
